export const Discord = [
    {
        type: "Discord",
        name: "UK Vegans General Discord",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/CSXu5x8",
        "": "",
    },
    {
        type: "Discord",
        name: "Mic The Vegan's Discord",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/c87PZ3K",
        "": "",
    },
    {
        type: "Discord",
        name: "Joey Carbstrong's Discord",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/7dehBwS",
        "": "",
    },
    {
        type: "Discord",
        name: "r/VeganCircleJerk",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/morallysuperior",
        "": "",
    },
    {
        type: "Discord",
        name: "Ultra Advocacy",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/BnuHEfGNPN",
        "": "",
    },
    {
        type: "Discord",
        name: "Vegan Dreamland",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/veg",
        "": "",
    },
    {
        type: "Discord",
        name: "Ask Yourself",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/dUPFfby",
        "": "",
    },
    {
        type: "Discord",
        name: "Debating with Vegans",
        category: "",
        author: "",
        description: "",
        link: "https://discord.gg/X3adSzbjux",
        "": "",
    },
]
